// libs
import React from "react";
import { Switch, Route, Redirect } from "react-router-dom";
import queryString from "query-string";
import moment from "moment";
// components
import ErrorBoundary from "../../../pages/Error/ErrorBoundary";
import NotFoundBundle from "../../../containers/NotFoundBundle";
// dataSources
import {
  AsyncCalendarContainer,
  AsyncTimeContainer,
  AsyncStatisticPageContainer,
  AsyncHolidaySettingContainer,
  AsyncQRcodeSettingContainer,
  AsyncWorkedShiftContainer,
  AsyncLeaveTypeSettingContainer,
  AsyncWriteNewReportsContainer,
  AsyncAllDailyReportsContainer,
  AsyncTemplateDailyReportContainer,
} from "../../../dataSources/Dashboard";
// others
import CONSTANTS from "../../../constants";
import { getCurrentBranchJSON } from "../../../config.js";

const {
  VIEW_DAILY_REPORT_TEMPLATE,
  VIEW_HOLIDAY,
  VIEW_QR_CODE,
  VIEW_WORK_SHIFT,
  VIEW_STATISTIC,
  VIEW_SETTING_LEAVE_TYPE,
  VIEW_CALENDAR,
  VIEW_TIME_CHECK,
  VIEW_ALL_DAILY_REPORT,
  VIEW_MY_DAILY_REPORT,
} = CONSTANTS.PRIVILEGE;
/**
 * @namespace
 * @property {Object}  props
 * @property {Object}  state
 */
const ContentDashBoard = ({ props, state }) => {
  const { userAuthorities, location } = props;

  return (
    <ErrorBoundary>
      <Switch>
        <Route
          path={`/${getCurrentBranchJSON().code}`}
          exact
          render={() => <Redirect to={"/time"} />}
        />
        {/* {userAuthorities.includes(VIEW_DAILY_ANALYSIS) && (
          <Route
            path="/dashboard"
            exact
            render={() => <Redirect to={"/dashboard/daily-analysis"} />}
          />
        )}
        {userAuthorities.includes(VIEW_DAILY_ANALYSIS) && (
          <Route
            path="/dashboard/daily-analysis"
            component={AsyncDailyAnalysisContainer}
          />
        )}
        {userAuthorities.includes(VIEW_USER_ANALYSIS) && (
          <Route
            path="/dashboard/user-analysis"
            component={AsyncUserAnalysisContainer}
          />
        )} */}
        {userAuthorities.includes(VIEW_STATISTIC) && (
          <Route
            path="/dashboard/statistic"
            exact
            render={() => {
              if (
                queryString.parse(location.search).page !== undefined &&
                queryString.parse(location.search).size !== undefined
              ) {
                return <AsyncStatisticPageContainer {...props} />;
              }

              return (
                <Redirect
                  to={`/dashboard/statistic?page=1&size=10&branch=${
                    getCurrentBranchJSON().code
                  }&zone=${getCurrentBranchJSON().zone}&fromDate=${moment()
                    .startOf("month")
                    .format("YYYY-MM-DD")}&toDate=${moment()
                    .endOf("month")
                    .format("YYYY-MM-DD")}&isDefault=true`}
                />
              );
            }}
          />
        )}
        {userAuthorities.includes(VIEW_TIME_CHECK) && (
          <Route path="/time/:key" component={AsyncTimeContainer} />
        )}
        {userAuthorities.includes(VIEW_TIME_CHECK) && (
          <Route path="/time" component={AsyncTimeContainer} />
        )}
        {userAuthorities.includes(VIEW_CALENDAR) && (
          <Route
            path="/calendar"
            exact
            render={() => <AsyncCalendarContainer {...state} {...props} />}
          />
        )}
        {userAuthorities.includes(VIEW_DAILY_REPORT_TEMPLATE) && (
          <Route
            path="/setting/template-daily-report"
            component={AsyncTemplateDailyReportContainer}
          />
        )}
        {userAuthorities.includes(VIEW_SETTING_LEAVE_TYPE) && (
          <Route
            path="/setting/leave-type"
            component={AsyncLeaveTypeSettingContainer}
          />
        )}
        {userAuthorities.includes(VIEW_HOLIDAY) && (
          <Route
            path="/setting/holiday"
            component={AsyncHolidaySettingContainer}
          />
        )}
        {userAuthorities.includes(VIEW_QR_CODE) && (
          <Route
            path="/setting/qrcode"
            component={AsyncQRcodeSettingContainer}
          />
        )}
        {userAuthorities.includes(VIEW_WORK_SHIFT) && (
          <Route
            path="/profile/worked-shift"
            component={AsyncWorkedShiftContainer}
          />
        )}
        {/* {userAuthorities.includes(VIEW_LEAVE_TYPE) && (
          <Route
            path="/profile/leave-type"
            component={AsyncLeaveHistoryContainer}
          />
        )} */}
        {userAuthorities.includes(VIEW_MY_DAILY_REPORT) && (
          <Route
            path="/daily-report/my-report"
            component={AsyncWriteNewReportsContainer}
          />
        )}
        {userAuthorities.includes(VIEW_ALL_DAILY_REPORT) && (
          <Route
            path="/daily-report/all-reports"
            component={AsyncAllDailyReportsContainer}
          />
        )}
        <Route path="/" exact component={AsyncTimeContainer} />
        <Route component={NotFoundBundle} />
      </Switch>
    </ErrorBoundary>
  );
};
export default ContentDashBoard;
